<div class="page gray-font-color font-family">
  <div class="header-navigation-back" >
    <div class="back-icon" (click)="backAction()"><mat-icon svgIcon="left-arrow"></mat-icon></div>
    <div  class="header-text">Trainings & Certifications</div>
  </div>
  @if (loading) {
    <app-loading-gif></app-loading-gif>
  }
  @if (!loading) {
    <div class="content">
      <div class="documents-list-container">
        <div class="documents-list">
          <!-- MELT -->
          <div class="document-item"
               [ngClass]="melt?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('MandatoryEntryLevelTraining', melt?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">MELT</h3>
              <p class="document-subtitle">Mandatory Entry Level Training</p>
              <p class="document-status">{{ melt?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (melt?.isPresent && melt?.issuingOrganization) {
                <p class="issuing-org">{{ melt?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ melt?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Hours of Service -->
          <div class="document-item"
               [ngClass]="hos?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('HoursOfService', hos?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">HoS</h3>
              <p class="document-subtitle">Hours of Service</p>
              <p class="document-status">{{ hos?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (hos?.isPresent && hos?.issuingOrganization) {
                <p class="issuing-org">{{ hos?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ hos?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Transportation of Dangerous Goods -->
          <div class="document-item"
               [ngClass]="transportationOfDangerousGoods?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('TransportationOfDangerousGoods', transportationOfDangerousGoods?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">TDG</h3>
              <p class="document-subtitle">Transportation of Dangerous Goods</p>
              <p class="document-status">{{ transportationOfDangerousGoods?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (transportationOfDangerousGoods?.isPresent && transportationOfDangerousGoods?.issuingOrganization) {
                <p class="issuing-org">{{ transportationOfDangerousGoods?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ transportationOfDangerousGoods?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Hazardous Materials Endorsement -->
          <div class="document-item"
               [ngClass]="hazardousMaterial?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('HazardousMaterialsEndorsement', hazardousMaterial?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">HME</h3>
              <p class="document-subtitle">Hazardous Materials Endorsements</p>
              <p class="document-status">{{ hazardousMaterial?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (hazardousMaterial?.isPresent && hazardousMaterial?.issuingOrganization) {
                <p class="issuing-org">{{ hazardousMaterial?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ hazardousMaterial?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Emergency Response Training -->
          <div class="document-item"
               [ngClass]="emergencyResponseTrainingDocument?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('EmergencyResponseTraining', emergencyResponseTrainingDocument?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Emergency Response</h3>
              <p class="document-subtitle">Spill Response / Emergency Response Training</p>
              <p class="document-status">{{ emergencyResponseTrainingDocument?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (emergencyResponseTrainingDocument?.isPresent && emergencyResponseTrainingDocument?.issuingOrganization) {
                <p class="issuing-org">{{ emergencyResponseTrainingDocument?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ emergencyResponseTrainingDocument?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- WHMIS -->
          <div class="document-item"
               [ngClass]="workplaceHazardousSystem?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('WorkplaceHazardousMaterialsInformationSystem', workplaceHazardousSystem?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">WHMIS</h3>
              <p class="document-subtitle">Workplace Hazardous Materials Information System</p>
              <p class="document-status">{{ workplaceHazardousSystem?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (workplaceHazardousSystem?.isPresent && workplaceHazardousSystem?.issuingOrganization) {
                <p class="issuing-org">{{ workplaceHazardousSystem?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ workplaceHazardousSystem?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Vehicle Inspection -->
          <div class="document-item"
               [ngClass]="vehicleInspections?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('VehicleInspections', vehicleInspections?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Vehicle Inspection</h3>
              <p class="document-subtitle">Vehicle Inspections</p>
              <p class="document-status">{{ vehicleInspections?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (vehicleInspections?.isPresent && vehicleInspections?.issuingOrganization) {
                <p class="issuing-org">{{ vehicleInspections?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ vehicleInspections?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Cargo Securement -->
          <div class="document-item"
               [ngClass]="cargoSecurement?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('CargoSecurement', cargoSecurement?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Cargo Securement</h3>
              <p class="document-subtitle">Cargo Securement Training</p>
              <p class="document-status">{{ cargoSecurement?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (cargoSecurement?.isPresent && cargoSecurement?.issuingOrganization) {
                <p class="issuing-org">{{ cargoSecurement?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ cargoSecurement?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Defensive Driving -->
          <div class="document-item"
               [ngClass]="defensiveDriving?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('DefensiveDriving', defensiveDriving?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Defensive Driving</h3>
              <p class="document-subtitle">Defensive Driving Training</p>
              <p class="document-status">{{ defensiveDriving?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (defensiveDriving?.isPresent && defensiveDriving?.issuingOrganization) {
                <p class="issuing-org">{{ defensiveDriving?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ defensiveDriving?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Winter Driving -->
          <div class="document-item"
               [ngClass]="winterDriving?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('WinterDriving', winterDriving?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Winter Driving</h3>
              <p class="document-subtitle">Winter Driving Training</p>
              <p class="document-status">{{ winterDriving?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (winterDriving?.isPresent && winterDriving?.issuingOrganization) {
                <p class="issuing-org">{{ winterDriving?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ winterDriving?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Mountain Driving -->
          <div class="document-item"
               [ngClass]="mountainDriving?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('MountainDriving', mountainDriving?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Mountain Driving</h3>
              <p class="document-subtitle">Mountain Driving Training</p>
              <p class="document-status">{{ mountainDriving?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (mountainDriving?.isPresent && mountainDriving?.issuingOrganization) {
                <p class="issuing-org">{{ mountainDriving?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ mountainDriving?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>

          <!-- Fatigue Management -->
          <div class="document-item"
               [ngClass]="fatigueManagement?.isPresent ? 'status-completed' : 'status-incomplete'"
               (click)="uploadFile('FatigueManagementTraining', fatigueManagement?.isPresent)">
            <div class="document-icon-wrapper">
              <mat-icon class="document-icon training-docs" svgIcon="training-docs"></mat-icon>
            </div>
            <div class="document-info">
              <h3 class="document-title">Fatigue Management</h3>
              <p class="document-subtitle">Fatigue Management Training</p>
              <p class="document-status">{{ fatigueManagement?.isPresent ? 'Uploaded' : 'Not Uploaded' }}</p>
              @if (fatigueManagement?.isPresent && fatigueManagement?.issuingOrganization) {
                <p class="issuing-org">{{ fatigueManagement?.issuingOrganization }}</p>
              }
            </div>
            <div class="status-indicator">
              <mat-icon class="status-icon">{{ fatigueManagement?.isPresent ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
